'use client';

import { c as _c } from "react/compiler-runtime";
import { Toggle as TogglePrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import { label } from '../typography/Label';
import type { VariantProps } from 'tailwind-variants';
const toggle = tv({
  extend: label,
  base: `
    bg-background-secondary
    text-content-secondary
    hover:data-[state=off]:bg-background-tertiary
    dark:hover:data-[state=off]:bg-background-secondary
    data-[state=on]:bg-background-primary
    data-[state=on]:text-content-primary
    data-[state=on]:border-border-primary
    aria-invalid:ring-destructive/20
    dark:aria-invalid:ring-destructive/40
    aria-invalid:border-destructive
    focus-visible:border-border-primary
    inline-flex
    items-center
    justify-center
    gap-2
    border
    border-transparent
    transition-[background,border,color,box-shadow]
    outline-none
    disabled:pointer-events-none
    data-[state=off]:cursor-pointer
    [&_svg]:pointer-events-none
    [&_svg]:shrink-0
    [&_svg:not([class*=_size-_])]:size-4
    font-medium
  `,
  variants: {
    variant: {
      bounded: `
        rounded-sm
      `,
      unbounded: `
        rounded-full
      `
    },
    size: {
      sm: `h-6 min-w-6 px-2.5`,
      md: `h-8 min-w-8 px-3.5`,
      lg: `h-10 min-w-10 px-4.5`
    }
  },
  defaultVariants: {
    size: 'md',
    variant: 'bounded'
  }
});
type ToggleProps = React.ComponentProps<typeof TogglePrimitive.Root> & VariantProps<typeof toggle>;
function Toggle(t0) {
  const $ = _c(12);
  let className;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size || $[7] !== variant) {
    t1 = toggle({
      variant,
      size,
      className
    });
    $[5] = className;
    $[6] = size;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props || $[10] !== t1) {
    t2 = <TogglePrimitive.Root className={t1} data-slot="toggle" {...props} />;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
export { Toggle, toggle, type ToggleProps };